const messages = {
  title: "Bonusový multiplikátor",
  bandBonusTitle: "Bonus na pneumatiku s multiplikátorom",
  amountLabel: "Min. počet pneumatík (*)",
  label: "Bonusový multiplikátor",
  desc: "Počet pneumatík Bridgestone a Firestone. Za pneumatiky Firestone nie je bonus v eurách.",
  goals: {
    loyal: "Verný",
    bronze: "Bronz",
    silver: "Striebro",
    gold: "Zlato",
    platinum: "Platina",
  },
  andMore: "a viac",
  chooseTarget: "Vybrať",
  selectTarget: "Vyberte si tu svoj ročný cieľ pre {year}:",
  multiplication: "Bonus sa násobí <b>{factor}</b>",
  minTyres: "<b>Minimum:</b> {tyre} pneumatiky",
};

export default {
  messages,
};
